module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "disallowed box-shadow--big"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/ico-not-ok.png")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "disallowed__header"
  }, [_vm._v(_vm._s(_vm.$t('YOU_CAN_NOT_DO_BRASTER')) + " "), _c('br'), _vm._v(_vm._s(_vm.$t('UNTIL_LACTATION_ENDS')))]), _vm._v(" "), _c('p', [_vm._v("\n        " + _vm._s(_vm.$t('IF_YOU_BOUGHT_PACKAGE'))), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.linkClicked(_vm.eSklepUrl + _vm.$t('LINK_CONTACT_MODAL'))
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CONTACT_WITH_US')))]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('EXTEND_EXPIRATION_DATE_PREGNANCY')) + "\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "font-small",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.linkClicked(_vm.eSklepUrl + _vm.$t('LINK_WARNINGS'))
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('GET_TO_KNOW_WARNINGS')) + " "), _c('img', {
    staticStyle: {
      "width": "14px"
    },
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "w160 app-btn app-btn-primary mt-3",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeModal()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('CLOSE_WINDOW')) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c6a2f89","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/survey-disallowed-by-pregnant.vue
// module id = 1169
// module chunks = 0